import { render, staticRenderFns } from "./n2ushoornFooter.vue?vue&type=template&id=62be9193&scoped=true&"
import script from "./n2ushoornFooter.vue?vue&type=script&lang=js&"
export * from "./n2ushoornFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be9193",
  null
  
)

export default component.exports